module.exports = __webpack_public_path__ + "img/4.688503bb.png";